// Session-based auth against tt-frankford-auth / tt-frankford-api.
// Mirrors the established sibling-app pattern (Shade Designer, Sales Support Map).
// Uses the shared axios instance with `withCredentials: true`.
import api from "./api";
import { IUser } from "@/models/user";

export default class AuthService {
  // POST /auth/login → { status, data: user }
  public async login(email: string, password: string): Promise<IUser> {
    const res = await api.post("/auth/login", { email, password });
    return (res.data?.data ?? res.data) as IUser;
  }

  // GET /auth/checkauth → { status, data: user } (401 when not authenticated)
  public async checkAuth(): Promise<IUser> {
    const res = await api.get("/auth/checkauth");
    return (res.data?.data ?? res.data) as IUser;
  }

  // POST /auth/logout
  public async logout(): Promise<void> {
    await api.post("/auth/logout", {});
  }
}
